export default "__VITE_ASSET__DZqmXTre__"